module.exports = __webpack_public_path__ + "static/img/BANNER_4.755bd9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/BANNER_4.png
// module id = gAWJ
// module chunks = 5